import { IDataRequestSummary } from '@vivli/features/data-requests/infrastructure/interface';
import { useActiveUserContext, useDataRequestFiltersContext } from '@vivli/core/infrastructure/context';
import { useEffect, useState } from 'react';

export function useAwaitingUserActionDataRequests(dataRequests: IDataRequestSummary[]) {
    const [requests, setRequests] = useState<IDataRequestSummary[]>();
    const dataRequestFilters = useDataRequestFiltersContext();

    const { user } = useActiveUserContext();

    useEffect(() => {
        if (!dataRequests) {
            return;
        }

        const awaitingUserActionRequests = dataRequestFilters.filterAwaitingUserActionRequests(dataRequests, user);
        setRequests(awaitingUserActionRequests);
    }, [dataRequests]);

    return requests;
}
